import React from 'react';
import ReferencesLogic from './ReferencesLogic';
/**
 * Display for References components.
 * @return {References}
 */
function ReferencesPage() {
  return (
    <div className='centerScreen'>
      <div className='centerPart'>
        <ReferencesLogic/>
      </div>
    </div>
  );
}

export default ReferencesPage;
